import { render, staticRenderFns } from "./AccountSellerList.vue?vue&type=template&id=8b96e250&"
import script from "./AccountSellerList.vue?vue&type=script&lang=js&"
export * from "./AccountSellerList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports